module.exports = __webpack_public_path__ + "img/placeholder.6d6c97f3.jpg";